export function formatDate(date: Date, locales: string) {
    return `${date.toLocaleDateString(locales)} ${date.toLocaleTimeString()}`;
}
